require("data/empty_state");

class EmptyState extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	render() {
		if (this.props.type == BOOKS) {
			var text = "Your students have not done any book activity."
			var emptyStateContent = (
				<div>
					<p>{ text }</p>
					<div className="tableContainer">
						<div className="tableRow"></div>
						<div className="tableRow"></div>
						<div className="tableRow"></div>
					</div>
				</div>
			)
		} else if (this.props.type == QUIZZES || this.props.type == PRACTICE_QUESTIONS) {
			if (this.props.type == QUIZZES) {
				var emptyNote = "Your students have not taken any quizzes.";
			} else {
				var emptyNote = "Your students have not answered any practice questions.";
			}
			var emptyStateContent = (
				<div className="contentContainer">
					<p className="emptyNote">{ emptyNote }</p>
					<div className="emptyText emptyTextShort"></div>
					<div className="emptyText emptyTextMiddle"></div>
					<div className="emptyText emptyTextShort emptyTextFinal"></div>
				</div>
			)
		} else if (this.props.type == LOGS) {
			var emptyStateContent = (
				<div className="logContainer">
					<p className="emptyNote">Your students have not logged any reading.</p>
					<div className="emptyText"></div>
					<div className="emptyText"></div>
					<div className="emptyText"></div>
				</div>
			)
		} else if (this.props.type == RL_GRAPH) {
			var emptyStateContent = (
				<div className="rlGraphContainer">
					<p>Your students have not done any book activity.</p>
					<div className="graphFrame">
						<div className="graphMiddleLine"></div>
						<div className="valuesLine"></div>
					</div>
				</div>
			)
		}
		return (
			<div className="emptyStateContainer">{ emptyStateContent }</div>
		);
	}
}

var BOOKS = "books";
var GOALS = "goals";
var QUIZZES = "quizzes";
var LOGS = "logs";
var PRACTICE_QUESTIONS = "practice-questions";
var RL_GRAPH = "reading-level-graph";

EmptyState.propTypes = PageStrictPropTypes({
	type: PropTypes.string,
	showFullData: PropTypes.bool
});

module.exports = EmptyState;


// WEBPACK FOOTER //
// ./modules/components/data/EmptyState.js